<template>
  <div id="joinPopup" class="join_st">
    <!-- 본인 인증 START-->
    <div class="images_wrap none">
      <router-link
        :to="{ name: 'store' }"
        class="an_a"
        aria-lable="e-alice 홈으로 이동"
      >
        <span class="svg_alice_b"></span>
        <span class="an_t">{{ $t('views.auth.join.authemail.ealice') }}</span>
      </router-link>
    </div>

    <div class="section full">
      <div class="inner flex">
        <div class="box_wrap" data-detail="id_search">
          <div class="box">
            <div class="box_title">
              <h2>{{ $t('views.auth.join.authemail.5391') }}</h2>
              <!-- <p class="guide_txt">{{ $t('views.auth.join.authemail.9453') }}</p> -->
            </div>

            <ul class="form_wrap">
              <li class="input_wrap num_auth">
                <label for="email" class="hidden">이메일 주소</label>
                <input
                  id="email"
                  v-model="email"
                  type="email"
                  class="input_t w-100"
                  name="phoneAuth"
                  :placeholder="$t('views.auth.join.authemail.3908')"
                  :readonly="isReadOnly"
                />

                <div class="btn_wrap">
                  <button
                    class="box_btn"
                    :class="isReadOnly ? ' dull' : ''"
                    @click="requestEmailCode"
                  >
                    <!-- 인증번호 불일치 시 알럿창 -->
                    <span class="an_t">{{
                      $t('views.auth.join.authemail.8094')
                    }}</span>
                  </button>
                </div>
              </li>
              <li class="input_wrap time_count">
                <label for="code" class="hidden">인증번호 입력</label>
                <input
                  id="code"
                  v-model="code"
                  type="text"
                  class="input_t w-100"
                  name="authCode"
                  :placeholder="$t('views.auth.join.authemail.480')"
                  :readonly="!isReadOnly"
                />
                <span class="count">{{ countdown }}</span>
              </li>
              <li class="btn_wrap">
                <button class="box_btn w-100" @click="verifyAuthCode">
                  <span class="an_t">{{ $t('library.deletemodal.ok') }}</span>
                </button>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <!-- ERROR MODAL -->
    <transition v-on-clickaway="toggleErrorModal" name="modal-fade">
      <Modal v-if="showErrorModal" @close="toggleErrorModal">
        <div class="ly_pop_wrap">
          <div class="ly_pop_content ly_pop_msg ly_txt">
            <div class="ly_pop_head">
              <a class="btn_ly_close svg_close" @click="toggleErrorModal"
                ><span>{{ $t('library.deletemodal.close') }}</span></a
              >
            </div>
            <div class="ly_inner">
              <p>
                {{ errorMessage }}
              </p>
            </div>
            <div class="btnWrap">
              <button class="box_btn w-full" @click="toggleErrorModal">
                <span class="an_t">{{ $t('library.deletemodal.close') }}</span>
              </button>
            </div>
          </div>
        </div>
      </Modal>
    </transition>
  </div>
</template>

<script>
import { AUTH_SEND_EMAIL_VERIFICATION, AUTH_VERIFY_EMAIL } from '@/store/types'
// import moment from 'moment'
export default {
  name: 'AuthPhone',
  data() {
    return {
      email: '',
      errorMessage: '',
      countdown: '',
      interval: null,
      code: '',
      defaultCountdownMin: 5,
      showErrorModal: false,
      terms: '',
      isReadOnly: false
    }
  },
  watch: {
    countdown(val) {
      if (val === '0:00') {
        this.clearCountdown()
      }
    }
  },
  async mounted() {
    this.terms = this.$route.params.terms
      ? this.$route.params.terms
      : await this.$store.dispatch('getCookie', 'ealice_mail1')
    if (!this.terms) {
      this.$router.push({ name: 'join_step1' })
    }
    const getCk = await this.$store.dispatch('getCookie', 'ealice_mail2')
    if (getCk) {
      this.email = atob(getCk.mail)
    }
    if (this.$route.query && this.$route.query.verify) {
      if (atob(this.$route.query.verify) === this.email) {
        this.isReadOnly = true
        this.$router.replace({ query: null })
        // await this.startCountdown()
      } else {
        this.errorMessage = `잘못된 접근입니다.`
        this.toggleErrorModal()
      }
    }
  },
  methods: {
    toggleErrorModal() {
      this.showErrorModal = !this.showErrorModal
    },
    clearCountdown() {
      clearInterval(this.interval)
      this.interval = null
      this.countdown = ''
    },
    // async startCountdown() {
    //   this.isReadOnly = true
    //   const that = this

    //   const end = moment().add(this.defaultCountdownMin, 'm')
    //   const getCk = await this.$store.dispatch('getCookie', 'ealice_mail2')
    //   if (this.interval) {
    //     this.clearCountdown()
    //   }
    //   if (getCk && atob(getCk.mail) === this.email) {
    //     if (this.interval) {
    //       this.clearCountdown()
    //     }
    //     const that = this
    //     let nowT = Math.floor((+new Date() - getCk.time) / 1000)
    //     const getMin = Math.floor((300 - nowT) / 60)
    //     const getSec = 60 - (nowT % 60)

    //     // this.defaultCountdownMin
    //     const end = moment().add(getMin, 'm').add(getSec, 's')
    //     // const now = moment.add()
    //     this.interval = setInterval(() => {
    //       const now = moment()
    //       if (that.countdown === '0:00') {
    //         this.clearInterval()
    //         return
    //       }
    //       that.countdown = moment(end.diff(now)).format('m:ss')
    //     }, 1000)
    //     return
    //   } else {
    //     this.interval = setInterval(() => {
    //       if (that.countdown === '0:00') {
    //         this.clearInterval()
    //         return
    //       }
    //       const now = moment()
    //       that.countdown = moment(end.diff(now)).format('m:ss')
    //     }, 800)
    //   }
    // },
    async requestEmailCode() {
      if (this.isReadOnly) {
        return
      }
      const getCk = await this.$store.dispatch('getCookie', 'ealice_mail2')
      if (getCk && atob(getCk.mail) === this.email) {
        this.errorMessage = `입력하신 메일로 이미 인증번호를 보내드렸습니다.`
        this.isReadOnly = true
        this.toggleErrorModal()
        // await this.startCountdown()
        return
      } else {
        try {
          await this.$store.dispatch(AUTH_SEND_EMAIL_VERIFICATION, this.email)
          // await this.startCountdown()
          let time = +new Date()
          this.$store.dispatch('setCookie', {
            name: 'ealice_mail2',
            value: { mail: btoa(this.email), time: time },
            exp: 5
          })
          this.errorMessage = `[메일 발송 완료] 입력하신 메일로 인증번호를 보내드렸습니다.`
          this.isReadOnly = true
          this.toggleErrorModal()
        } catch (err) {
          this.errorMessage = `[${err.response.data.errorState.code}] ${err.response.data.errorState.message}`
          this.toggleErrorModal()
        }
      }
    },
    async verifyAuthCode() {
      const { email, code, terms } = this
      try {
        await this.$store.dispatch(AUTH_VERIFY_EMAIL, { email, code })
        const verifiedInfo = {
          email,
          type: 'email'
        }
        this.clearCountdown()
        this.$router.push({
          name: 'join_step3',
          params: { terms, verifiedInfo }
        })
      } catch (err) {
        this.errorMessage = err.response.data.errorState.message
        this.toggleErrorModal()
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>
